export function getPreferredLanguage() {
  return localStorage.getItem("preferredLang") || "en";
}

const SINGLE_LABEL_TLDS = new Set([
  "com",
  "org",
  "net",
  "edu",
  "gov",
  "io",
  "ai",
  "app",
  "dev",
  "us",
  "info",
  "biz",
  "cloud",
]);

function googTransCookieDomains(hostname) {
  if (!hostname || hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return [];
  }
  const parts = hostname.split(".");
  const tld = (parts[parts.length - 1] || "").toLowerCase();
  const maxStart = SINGLE_LABEL_TLDS.has(tld) ? parts.length - 2 : 0;
  const domains = [];
  for (let start = 0; start <= maxStart; start++) {
    if (parts.length - start < 2) break;
    const domain = parts.slice(start).join(".");
    domains.push(domain, `.${domain}`);
  }
  return [...new Set(domains)];
}

function clearGoogleTranslateCookies() {
  const expire =
    "googtrans=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;max-age=0";
  const host = window.location.hostname;
  const seen = new Set();
  const write = (domainSuffix) => {
    if (seen.has(domainSuffix)) return;
    seen.add(domainSuffix);
    document.cookie = expire + domainSuffix;
  };

  write("");
  for (const d of googTransCookieDomains(host)) {
    write(`;domain=${d}`);
  }
}

function setGoogleTranslateCookie(cookieValue) {
  clearGoogleTranslateCookies();
  const oneYear = 31536000;
  const host = window.location.hostname;
  const baseCookie = `googtrans=${cookieValue};path=/;max-age=${oneYear}`;

  document.cookie = baseCookie;

  if (host && host !== "localhost" && !/^\d+\.\d+\.\d+\.\d+$/.test(host)) {
    document.cookie = `${baseCookie};domain=${host}`;
    document.cookie = `${baseCookie};domain=.${host}`;
  }
}

export function applyPreferredLanguage(lang) {
  const safeLang = lang === "es" ? "es" : "en";

  if (safeLang === "es") {
    setGoogleTranslateCookie("/en/es");
  } else {
    clearGoogleTranslateCookies();
  }

  localStorage.setItem("preferredLang", safeLang);

  const overlay = document.getElementById("lang-overlay");
  if (overlay) {
    overlay.style.display = "flex";
  }

  setTimeout(() => {
    window.location.reload();
  }, 250);
}
